import React from "react";
import { PropTypes } from "prop-types";

import "css/admin/utils/loader-editor.scss";

function LoaderEditor({ children, classnames, loading }) {
  return (
    <>
      {loading ? (
        <div className="loader-editor-container">
          <div className={`preloader ${classnames}`}>
            <span />
            <span />
            <span />
          </div>
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
}

LoaderEditor.propTypes = {
  children: PropTypes.node,
  classnames: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

export default LoaderEditor;
